import { transparentize } from 'polished';
import React from 'react';

import type { DsrIconProps } from './wrappers';
import { Svg } from './wrappers';

const Icon = ({
  primaryColor,
  selectedColor,
  selected,
  ...svgProps
}: DsrIconProps): JSX.Element => (
  <Svg viewBox="0 0 24 24" version="1.1" {...svgProps}>
    <title>DSR/icon/update:default</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M 3 8 L 3 16 L 7.171875 16 L 7 15.828125 L 7 11 L 11.828125 11 L 16.828125 16 L 21 16 L 21 8 Z M 3 8 "
        fill={selected ? selectedColor : transparentize(0.7, primaryColor)}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 9 15 L 9 13 L 11 13 L 16.144531 18.144531 L 14.144531 20.144531 Z M 16.5625 21.855469 L 17.855469 20.5625 C 18.050781 20.367188 18.050781 20.050781 17.855469 19.855469 L 16.855469 18.855469 L 14.855469 20.855469 L 15.855469 21.855469 C 16.050781 22.050781 16.363281 22.050781 16.5625 21.855469 Z M 16.5625 21.855469 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 20 7 L 4 7 C 2.898438 7 2 7.898438 2 9 L 2 15 C 2 16.101562 2.898438 17 4 17 L 8.171875 17 L 7 15.828125 L 7 15 L 4 15 L 4 9 L 20 9 L 20 15 L 15.828125 15 L 17.828125 17 L 20 17 C 21.101562 17 22 16.101562 22 15 L 22 9 C 22 7.898438 21.101562 7 20 7 Z M 20 7 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
    </g>
  </Svg>
);

export default Icon;
